import * as React from 'react'
import { Settings } from '../../services/AppSettingsService';
import { queryNoTracking } from '../../services/DataService';
import { accentUtils, def, from } from '../../services/HelperService';
import { AccentSpinner } from '../AccentSpinner';
import { AccentComboUnbound } from '../unbound/AccentComboUnbound';
const query_PrintSetting_Select = queryNoTracking("PrintSetting_Select");

/**
 * Print-setting picker filtered to one document type (`type` = the DocumentTemplateTypes code; no type = every
 * setting). The remembered default (`defaultValue`, else the user's DefaultPrintSettings) only applies when it is
 * one of the FILTERED settings: a default remembered from an invoice print must not be reported as the selection
 * for an order confirmation, where the combo could not even show it. `onReady` fires once, with that resolved
 * default (or null), after the list for the type is known.
 */
export const PrintSettingSelection = props => {
    const documentTypeFilter = props.type;
    const defaultValue = def(props.defaultValue, Settings.GetAppSettings().DefaultPrintSettings);
    const [data, setData] = React.useState(null);
    const [filteredData, setFilteredData] = React.useState(null);
    const [resolvedDefault, setResolvedDefault] = React.useState(null);
    const readyFired = React.useRef(false);

    const onChanged = React.useCallback(e => {
        props.onChange(e);
        Settings.SetAppSettings({ DefaultPrintSettings: e });
    }, [props]);

    // Filter data whenever the original data or type changes, and resolve the remembered default against the filtered list
    React.useEffect(() => {
        if (!data) return;
        const filtered = documentTypeFilter
            ? from(data).where(item => item.Type === documentTypeFilter).toArray()
            : data;
        const defaultExists = !accentUtils.isEmpty(defaultValue) && from(filtered).any(i => i.ID == defaultValue);
        const resolved = defaultExists ? defaultValue : null;
        setFilteredData(filtered);
        setResolvedDefault(resolved);
        if (!readyFired.current) {
            readyFired.current = true;
            if (props.onReady) props.onReady(resolved);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, documentTypeFilter]);

    // Load initial data
    React.useEffect(() => {
        query_PrintSetting_Select.getAll().then(r => setData(r));
    }, []);

    if (filteredData == null) return <AccentSpinner />;

    return (
        <AccentComboUnbound
            displayField="Name"
            valueField="ID"
            defaultValue={resolvedDefault}
            onChange={onChanged}
            label="Product Settings"
            data={filteredData}
        />
    );
};
